import React, { useState } from "react";
import PurchasesTable from "./PurchasesTable";
import CommissionsTable from "./CommissionsTable";
import UsersTable from "./UsersTable";
// import TransfersTable from "./TransfersTable";
import "../styles.css";

const TAB_CONFIG = {
  purchases: {
    label: "Purchases",
    component: PurchasesTable,
  },
  commissions: {
    label: "Commissions",
    component: CommissionsTable,
  },
  profit: {
    label: "Profit",
    component: null,
    disabled: true,
  },
  distribution: {
    label: "Distribution",
    component: null,
    disabled: true,
  },
  users: {
    label: "Users",
    component: UsersTable,
  },
};

function AdminTablesTabs({
  provider,
  signer,
  sharesAddress,
  refreshKey,
  isOwner,
}) {
  const [activeTab, setActiveTab] = useState("purchases");

  console.log("📊 AdminTablesTabs rendered", {
    provider: !!provider,
    sharesAddress,
    refreshKey,
    activeTab,
  });

  const ActiveComponent = TAB_CONFIG[activeTab].component;

  return (
    <div className="shared-space shared-margin">
      <div className="CommissionsDetails">
        <h2 className="table-label">Admin Tables</h2>
        <div className="transactions-filter-buttons mb-3 table-label totalCommission">
          {Object.entries(TAB_CONFIG).map(([key, config]) => (
            <button
              key={key}
              type="button"
              className={`transaction-filter-btn ${
                activeTab === key ? "active" : ""
              }`}
              disabled={config?.disabled}
              onClick={() => {
                if (!config?.disabled) {
                  setActiveTab(key);
                }
              }}
            >
              {config.label}
            </button>
          ))}
        </div>
        <div className="borderSpace"></div>
      </div>

      <div className="admin-tables-content">
        {ActiveComponent ? (
          <ActiveComponent
            provider={provider}
            signer={signer}
            refreshKey={refreshKey}
            isOwner={isOwner}
            sharesAddress={sharesAddress}
          />
        ) : (
          <div className="table-no-data">Coming soon.</div>
        )}
      </div>
    </div>
  );
}

export default AdminTablesTabs;
